import { ChangeDetectionStrategy, Component, HostBinding, OnInit, ViewEncapsulation } from "@angular/core";
import { PlatformService } from "@obg/ngx.global.evo";
import { lightFormat } from "date-fns";
import { interval, Observable } from "rxjs";
import { distinctUntilChanged, map } from "rxjs/operators";

@Component({
	selector: "obg-ksa-regulatory-bar",
	templateUrl: "./ksa-regulatory-bar.container.html",
	styleUrls: ["./ksa-regulatory-bar.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class KsaRegulatoryBarContainer implements OnInit {
	@HostBinding("class.obg-ksa-regulatory-bar") hostCssClass = true;

	time$: Observable<string | undefined> | undefined;

	constructor(private platformService: PlatformService) {}

	ngOnInit() {
		this.time$ = this.platformService.forClient(() =>
			interval(1000).pipe(
				map(() => lightFormat(this.getNetherlandsDateAndTime(), "HH:mm")),
				distinctUntilChanged()
			)
		);
	}

	private getNetherlandsDateAndTime() {
		const currentNetherlandsDate = new Date().toLocaleString("en-US", {
			timeZone: "Europe/Amsterdam",
		});

		const parsedNetherlandsDate = new Date(Date.parse(currentNetherlandsDate));

		return parsedNetherlandsDate;
	}
}
